import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { GenBundleItem, GenBundle } from "../../../models/bundle.model";
import { GenLoadingEnum } from "../../../enums/loading.enum";

@Component({
    selector: 'gen-bundle-slide',
    templateUrl: './bundle-slide.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenBundleSlideComponent {
  @Input() isActive: boolean;
  @Input() bundle: GenBundle;
  @Input() errorMessages: string[];
  @Input() loading: GenLoadingEnum;
  @Output() addBundleToTheCart = new EventEmitter<GenBundle>();

  GenLoadingEnum = GenLoadingEnum;

  constructor() {
  }

  trackByProduct(_: number, item: GenBundleItem) {
    return item.code;
  }
}
